import React, {FunctionComponent} from 'react';
import {Avatar} from "antd";
import {useTranslation} from "react-i18next";

import styles from './Request.module.scss';
import {formatDate} from "../../utils/date.utils";
import CenterButton from "../shared/button/CenterButton";

interface RequestProps {
    id: string
    avatarURL: string
    name: string
    requestedDate: string
    onDecline: (id: string) => void
    onAccept: (id: string) => void
    declineLabel?: string
    acceptLabel?: string
    disabledAccept?: boolean
    disabledDecline?: boolean
}

export const Request: FunctionComponent<RequestProps> = (props) => {
    const {t} = useTranslation();
    return (
        <>
            <div className={styles.FriendRequestContainer}>
                <Avatar src={props.avatarURL} size={68}/>
                <div className={styles.RequestDetailContainer}>
                    <span style={{fontWeight: "bold"}}>{props.name}</span>
                    <div>
                        <CenterButton
                            ghost
                            onClick={() => {
                                props.onDecline(props.id);
                            }}
                            small
                            style={{marginRight: ".5rem"}}
                        >
                            {props.declineLabel ? props.declineLabel : t("Decline")}
                        </CenterButton>
                        <CenterButton
                            small
                            onClick={() => {
                                props.onAccept(props.id);
                            }}
                            disabled={props.disabledAccept}
                        >
                            {props.acceptLabel ? props.acceptLabel : t("Accept")}
                        </CenterButton>
                    </div>
                </div>
            </div>
            <div className={styles.Date}>{formatDate(props.requestedDate)}</div>
        </>
    )
}